import React from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { useNavigate } from "react-router-dom";

const NotFound = ({ message }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();

  return (
    <div className="text-3xl mt-24 items-center flex flex-col justify-items-center">
      <img
        src="/not-found.png"
        alt="not found"
        className="mb-4 filter invert"
      />
      {message ?? t("patchnotfound")}
      <button className="btn btn-info shadow-lg text-white mx-full mt-4" onClick={() => navigate("/")}>Tüm Yamaları Gör</button>
    </div>
  );
};

export default NotFound;
